<template>
  <div class="seeIt">
    <div class="topBar" >
       
        <div  alt="" class="question" @click="openHelp()"></div> 
       <div alt="" class="info" id="info" @click="info()"> </div> 
       <div  class="arrow" id="prevArrow"
       @click="goToPreviousScreen"  ></div> 
       <div class='arrow1' @click="goToNextScreen" id="nextArrow" ></div> 
  </div>
  <router-view id="screen" class="screen"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
var elementNext, name, elementPrev;
export default {
  props: {
    chapterId: String,
    screenId: String,
    storyboardScreens: Array
  },
  data() {
    return {
      isNotLast: true
    };
  },

  methods: {
    goToPreviousScreen() {
      elementNext = document.getElementById("nextArrow");
      elementNext.className = "arrow1";
      this.isNotLast = true;
      let currentIndex = -1;
      let prevChapter = null;
      let currentChapter = null;

      for (
        let chapterIndex = 0;
        chapterIndex < this.chapters.length;
        chapterIndex++
      ) {
        currentChapter = this.chapters[chapterIndex];
        currentIndex = currentChapter.storyboardScreens.findIndex(
          x => x.screenId == this.screenId
        );
        if (currentIndex > -1) {
          //we found chapter which has current screen

          prevChapter = this.chapters[chapterIndex - 1];
          break;
        }
      }
      if (!currentChapter) return;

      let screenImagesFolderName = currentChapter.screenImagesFolderName;
      let storyboardScreens = currentChapter.storyboardScreens;
      let chapterId = currentChapter.chapterId;
      let prevScreen = currentChapter.storyboardScreens[currentIndex - 1];
      let prevScreen2 = currentChapter.storyboardScreens[currentIndex - 2];
      if (prevScreen2 == undefined) {
        if (chapterId == "see-it") {
          elementPrev = document.getElementById("prevArrow");
          elementPrev.className = "arrowPrevGrey";
        }
      }
      if (!prevScreen) {
        //Next chapter
        if (prevChapter) {
          chapterId = prevChapter.chapterId;
          prevScreen =
            prevChapter.storyboardScreens[
              prevChapter.storyboardScreens.length - 1
            ];
          storyboardScreens = prevChapter.storyboardScreens;
          screenImagesFolderName = prevChapter.screenImagesFolderName;
        }
      }
      if (!prevScreen) return;
      let prevScreenId = prevScreen.screenId;
      this.$router.push({
        name: "chapter.screen",
        params: {
          chapterId: chapterId,
          screenId: prevScreenId,
          screenImagesFolderName: screenImagesFolderName,
          storyboardScreens: storyboardScreens
        }
      });
    },
    goToNextScreen() {
      elementPrev = document.getElementById("prevArrow");
      elementPrev.className = "arrow";
      let currentIndex = -1;
      let nextChapter = null;
      let currentChapter = null;

      for (
        let chapterIndex = 0;
        chapterIndex < this.chapters.length;
        chapterIndex++
      ) {
        currentChapter = this.chapters[chapterIndex];
        currentIndex = currentChapter.storyboardScreens.findIndex(
          x => x.screenId == this.screenId
        );
        if (currentIndex > -1) {
          //we found chapter which has current screen

          nextChapter = this.chapters[chapterIndex + 1];
          break;
        }
      }
      if (!currentChapter) return;

      let screenImagesFolderName = currentChapter.screenImagesFolderName;
      let storyboardScreens = currentChapter.storyboardScreens;
      let chapterId = currentChapter.chapterId;
      let nextScreen = currentChapter.storyboardScreens[currentIndex + 1];
      if (!nextScreen) {
        //Next chapter
        if (this.chapterId == "share" && !nextScreen) {
          elementNext = document.getElementById("nextArrow");
          name = "arrowNextGrey";
          elementNext.className = name;
        }

        if (nextChapter) {
          chapterId = nextChapter.chapterId;
          nextScreen = nextChapter.storyboardScreens[0];
          storyboardScreens = nextChapter.storyboardScreens;
          screenImagesFolderName = nextChapter.screenImagesFolderName;
        }
      }
      if (!nextScreen) return;
      let nextScreenId = nextScreen.screenId;
      this.$router.push({
        name: "chapter.screen",
        params: {
          chapterId: chapterId,
          screenId: nextScreenId,
          screenImagesFolderName: screenImagesFolderName,
          storyboardScreens: storyboardScreens
        }
      });
    },

    openHelp() {
      this.$store.commit("HIDE_ALLERT");
      this.$store.commit("IS_HELP_SHOWN");
    },
    info() {
      if (this.chapterId == "learn") {
        this.$store.commit("HIDE_ALLERT");
      } else if (!this.showDismissibleAlert) {
        this.$store.commit("SHOW_ALLERT");
      } else {
        this.$store.commit("HIDE_ALLERT");
      }
    }
  },
  mounted() {
    if (this.chapterId == "learn") {
      var elementInfo = document.getElementById("info");
      elementNext = document.getElementById("nextArrow");
      elementNext.className = "arrowNextGrey";
      elementInfo.className = "greyInfo";
    }
    if (this.chapterId == "see-it") {
      elementPrev = document.getElementById("prevArrow");
      elementPrev.className = "arrowPrevGrey";
    }
    this.$store.commit("TOP_BAR_IS_SHOWN");
    if (this.currentScreen) {
      if (this.chapterId == "learn") {
        this.$store.commit("HIDE_ALLERT");
      } else {
        this.$store.commit("SHOW_ALLERT");
      }
    }
    //this.$store.commit("HIDE_ALLERT");
  },
  computed: {
    ...mapGetters(["chapters", "showDismissibleAlert", "currentScreen"])
  },
  watch: {
    chapterId(newValue) {
      var elementInfo = document.getElementById("info");
      if (newValue == "learn") {
        elementNext = document.getElementById("nextArrow");
        elementNext.className = "arrowNextGrey";
        elementPrev = document.getElementById("prevArrow");
        elementPrev.className = "arrow";
        elementInfo.className = "greyInfo";
        this.$store.commit("HIDE_ALLERT");
      }
      if (newValue == "see-it") {
        elementPrev = document.getElementById("prevArrow");
        elementPrev.className = "arrowPrevGrey";
        elementNext = document.getElementById("nextArrow");
        elementNext.className = "arrow1";
        elementInfo.className = "info";
        //this.$store.commit("SHOW_ALLERT");
      }
      if (newValue != "see-it" && newValue != "learn") {
        elementNext = document.getElementById("nextArrow");
        elementNext.className = "arrow1";
        elementPrev = document.getElementById("prevArrow");
        elementPrev.className = "arrow";
        elementInfo.className = "info";
        //this.$store.commit("SHOW_ALLERT");
      }
    }
  }
};
</script>
<style  scoped lang="scss">
.screen {
  height: 651px;
  display: flex;
  justify-content: center;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.47;
  }
}
.greyInfo {
  content: url("../image/info-grey.png");
  width: 20px;
  height: 20px;
  margin-right: 26px;
  margin-bottom: 8px;
  margin-top: 10px;
}
.arrow:hover {
  background: url("../image/left-arrow-hover.png") no-repeat;
  background-size: 16px 17px;
  cursor: pointer;
}
.arrowNextGrey {
  background: url("../image/right-arrow-button.png") no-repeat;
  background-size: 16px 17px;
  margin-right: 18.5px;
  margin-bottom: 10px;
  margin-top: 11px;
  width: 16px;
  height: 17px;
}
.arrowPrevGrey {
  background: url("../image/left-arrow-button.png") no-repeat;
  width: 16px;
  height: 17px;
  background-size: 16px 17px;
  margin-right: 30.5px;
  margin-bottom: 10px;
  margin-top: 11px;
}
.arrow1:hover {
  background: url("../image/right-arrow-hover.png") no-repeat;
  background-size: 16px 17px;
  cursor: pointer;
}
.arrow1 {
  background: url("../image/right-arrow.png") no-repeat;
  width: 16px;
  height: 17px;
  background-size: 16px 17px;
  margin-right: 18.5px;
  margin-bottom: 10px;
  margin-top: 11px;
}
.arrow {
  background: url("../image/left-arrow.png") no-repeat;
  width: 16px;
  height: 17px;
  background-size: 16px 17px;
  margin-right: 30.5px;
  margin-bottom: 10px;
  margin-top: 11px;
}
.material-icons.md-18 {
  font-size: 18px;
}
.material-icons.md-light.md-inactive {
  color: rgba(255, 255, 255, 0.3);
}
.material-icons.md-light:hover {
  color: #f6b63a;
}
.bulb {
  margin-top: 5.5px;
  margin-right: 10px;
  width: 22px;
  height: 21px;
}
.info {
  background: url("../image/info.png");
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  margin-right: 26px;
  margin-bottom: 8px;
  margin-top: 10px;
  cursor: pointer;
}
.question {
  background: url("../image/help.png");
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  margin-right: 860px;
  margin-left: 14px;
  margin-bottom: 9px;
  margin-top: 9px;
  cursor: pointer;
}
.topBar {
  height: 38px;
  display: flex;
  flex-direction: row;
  background: black !important;
  justify-content: flex-end;
  align-content: center;
  align-items: flex-end;
  margin: 0;
  padding-right: 20px;
  padding-bottom: 10px;
  padding: 0;
}
.rectangle {
  position: absolute;
  opacity: 0.47;
  background-color: #eaac29;
  transition: opacity 5s ease;
  //animation: fadein ease 5s;
}
.seeIt {
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
}
img {
  object-fit: contain;
}
</style>

